import { render, staticRenderFns } from "./addRecordYouthToSquad.vue?vue&type=template&id=2556bfe7&scoped=true&"
import script from "./addRecordYouthToSquad.vue?vue&type=script&lang=js&"
export * from "./addRecordYouthToSquad.vue?vue&type=script&lang=js&"
import style0 from "./addRecordYouthToSquad.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./addRecordYouthToSquad.vue?vue&type=style&index=1&id=2556bfe7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2556bfe7",
  null
  
)

export default component.exports